var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEditPen = function SvgEditPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.585,
    height: 21.586
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.874 4.763 13.4 3.237l4.952 4.95-1.527 1.527z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.893 14.709 15.62 2.983l2.98 2.983L6.877 17.693l-3.977.994ZM15.62 0 1.989 13.631 0 21.586 7.955 19.6l13.63-13.634Z",
    fill: "#fff"
  })));
};

export default SvgEditPen;